module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tabs":{"collections":"... collections | browse 1 collection | browse {total} collections"}}}')
  delete Component.options._Ctor
}
